import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import { useLocation, Link } from 'react-router-dom'
import './App.css';
import { ThemeProvider, createTheme } from '@mui/material/styles';

const theme = createTheme({
    components: {
        MuiCard: {
            styleOverrides: {
                root: ({ ownerState }) => ({
                    ...(ownerState.className === 'root' && {
                        width: "92vw",
                        height: "34vh",
                        margin: "2vh 2vw",
                        maxWidth: "420px",
                        maxHeight: "340px",
                    }),
                    ...(ownerState.className === 'rootNull' && {
                        width: "92vw",
                        height: "34vh",
                        margin: "2vh 2vw",
                        maxWidth: "420px",
                        maxHeight: "140px",
                    })
                })
            }
        },
        MuiCardMedia: {
            styleOverrides: {
                root: {
                    height: "15vh",
                }
            }
        },
        MuiCardContent: {
            styleOverrides: {
                root: {
                    height: "12vh",
                    padding: "1.75vh",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    textAlign: "left"
                }
            }
        }
    },
});

export default function ArticleThumbnail(props) {
    const location = useLocation();
    return (
        <ThemeProvider theme={theme}>
            <div style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
            }}>
                <Link to={props.imgAlt1 !== "" ? `/content/${props.imgAlt1}` : location.pathname} className="links">
                    <Card className={props.imgUrl1 === "null" ?
                        "rootNull" : "root"}>
                        <CardActionArea>
                            {props.imgUrl1 === "null" ?
                                "" :
                                <CardMedia
                                    component="img"
                                    alt={props.imgAlt1}
                                    height="140"
                                    image={props.imgUrl1}
                                    title={props.imgAlt1}
                                />
                            }
                            <CardContent>
                                <Typography gutterBottom variant="h6" component="h2">
                                    {props.title1}
                                </Typography>
                                <Typography variant="body2" color="textSecondary" component="p">
                                    {props.details1}
                                </Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>
                </Link>

                {props.imgUrl2 === "empty" ?
                    "" :
                    <Link to={props.imgAlt2 !== "" ? `/content/${props.imgAlt2}` : location.pathname} className="links">
                        <Card className={props.imgUrl2 === "null" ?
                            "rootNull" : "root"
                        }>
                            <CardActionArea>
                                {props.imgUrl2 === "null" ?
                                    "" :
                                    <CardMedia
                                        component="img"
                                        alt={props.imgAlt2}
                                        height="140"
                                        image={props.imgUrl2}
                                        title={props.imgAlt2}
                                    />
                                }
                                <CardContent>
                                    <Typography gutterBottom variant="h6" component="h2">
                                        {props.title2}
                                    </Typography>
                                    <Typography variant="body2" color="textSecondary" component="p">
                                        {props.details2}
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Link>
                }

                {props.imgUrl3 === "empty" ?
                    "" :
                    <Link to={props.imgAlt3 !== "" ? `/content/${props.imgAlt3}` : location.pathname} className="links">
                        <Card className={props.imgUrl3 === "null" ?
                            "rootNull" : "root"
                        }>
                            <CardActionArea>
                                {props.imgUrl3 === "null" ?
                                    "" :
                                    <CardMedia
                                        component="img"
                                        alt={props.imgAlt3}
                                        height="140"
                                        image={props.imgUrl3}
                                        title={props.imgAlt3}
                                    />
                                }
                                <CardContent>
                                    <Typography gutterBottom variant="h6" component="h2">
                                        {props.title3}
                                    </Typography>
                                    <Typography variant="body2" color="textSecondary" component="p">
                                        {props.details3}
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Link>
                }
            </div>
        </ThemeProvider>
    );
}